module.exports = __webpack_public_path__ + "media/images/landing/icon-sherif-e1fc36ddd8486b55a02761a9c2ee4f7f.svg";